import { render } from "./FormHeader.vue?vue&type=template&id=751d8369&scoped=true"
import script from "./FormHeader.vue?vue&type=script&lang=js"
export * from "./FormHeader.vue?vue&type=script&lang=js"

import "./FormHeader.vue?vue&type=style&index=0&id=751d8369&scoped=true&lang=css"

import exportComponent from "C:\\Askar\\personalArea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-751d8369"]])

export default __exports__